import Vue from "vue"
import VJsoneditor from "v-jsoneditor"

Vue.use(VJsoneditor)

export default VJsoneditor
